import { makeVar } from '@apollo/client/core';
import { IntegrationOptions } from './integration.model';


export const integrationOptions = makeVar<IntegrationOptions>({ lastFetch:null, lastUpdated:null});
